<template>
  <!-- 发车合同管理 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button v-if="hasPermiss('admin:dispatch_contract:addDispatchContract')" class="glo_btnItems glo_bgcMainColor" @click="transportPlan">新增</el-button>
        <!-- <el-button class="glo_btnItems">导出 </el-button>
        <el-button class="glo_btnItems" @click="setMyModel"
          >表格设置
        </el-button>-->

        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="jtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <queryBtns :MoreConditions="MoreConditions" :showMoreBtns="false" @clerBtns="clerBtns" @queryBtn_ok="queryBtn_ok" @moreParam="moreParam"></queryBtns>
    </div>

    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'aaaa' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel" @click.stop="goYdDetails(scope.row)">{{ scope.row.memberNickname }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="100px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button v-if="
                  hasPermiss('admin:dispatch_contract:updateDispatchContract')
                " class="rbtns" @click.stop="WaybillEdit(scope.row)">修改</el-button>
              <el-button v-if="hasPermiss('admin:dispatch_contract:delDispatchContract')" class="rbtns" @click.stop="delBtns(scope.row)">删除</el-button>
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">调整线路</el-dropdown-item>
                  <el-dropdown-item command="b">出车确认</el-dropdown-item>
                  <el-dropdown-item command="c">车费分摊</el-dropdown-item>
                  <el-dropdown-item command="d">提成分摊</el-dropdown-item>
                  <el-dropdown-item command="d">出车完成</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 客户跟踪 -->
    <addCustomerTarck :showDia1="showDia1" :documentNumbers="documentNumbers" :documentStatus="documentStatus" :isdisabledStatus="true" @confirmAdd="confirmAdd" @closeDia1="closeDia1"></addCustomerTarck>

    <!-- 弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn('dialogFormREF')"
    >
      <div class="glo_dialogForm">
        <el-form v-if="isShowDialog" class="diaForm" ref="dialogFormREF" :model="dialogForm" label-width="120px" :rules="rulesForm">
          <div class="itemsRows">
            <el-form-item class="dialogFormItems" prop="number" label="发车合同编号:">
              <el-input v-model="dialogForm.number" clearable placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div class="itemTydw">
            <el-form-item class="dialogFormItems tydw" prop="shippingCompany" label="托运单位:">
              <el-input v-model="dialogForm.shippingCompany" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item class="dialogFormItems tydh" prop="shippingTel" label="托运联系电话:">
              <el-input v-model="dialogForm.shippingTel" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </div>
          <div class="itemTydw">
            <el-form-item class="dialogFormItems tydw" prop="receiptCompany" label="收货单位:">
              <el-input v-model="dialogForm.receiptCompany" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item class="dialogFormItems tydh" prop="receiptPhone" label="收货联系电话:">
              <el-input v-model="dialogForm.receiptPhone" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </div>
          <el-form-item class="dialogFormItems" prop="startCity" label="始发城市:">
            <el-input v-model="dialogForm.startCity" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="endCity" label="目的城市:">
            <el-input v-model="dialogForm.endCity" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="goodsName" label="货物名称:">
            <el-input v-model="dialogForm.goodsName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="totalCount" label="总件数:">
            <el-input v-model="dialogForm.totalCount" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="totalWeight" label="总重量:">
            <el-input v-model="dialogForm.totalWeight" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="totalVolume" label="总体积:">
            <el-input v-model="dialogForm.totalVolume" placeholder="请输入" clearable></el-input>
          </el-form-item>

          <el-form-item class="dialogFormItems" style="width: 100%" prop="carrierCompany" label="承运单位:">
            <el-input v-model="dialogForm.carrierCompany" placeholder="请输入" clearable></el-input>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="driverName" label="司机姓名:">
            <el-input v-model="dialogForm.driverName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="driverIdcard" label="身份证号:">
            <el-input v-model="dialogForm.driverIdcard" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="driverPhone" label="联系电话:">
            <el-input v-model="dialogForm.driverPhone" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="driverTel" label="家庭电话:">
            <el-input v-model="dialogForm.driverTel" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="driverAddress" label="司机住址:">
            <el-input v-model="dialogForm.driverAddress" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="carOwners" label="车主姓名:">
            <el-input v-model="dialogForm.carOwners" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="drivingLicenseNumber" label="行驶证号:">
            <el-input v-model="dialogForm.drivingLicenseNumber" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="driverLicenseNumber" label="驾驶证号:">
            <el-input v-model="dialogForm.driverLicenseNumber" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="engineNumber" label="发动机号:">
            <el-input v-model="dialogForm.engineNumber" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="carFrameNumber	" label="车架号码:">
            <el-input v-model="dialogForm.carFrameNumber" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="carModel	" label="车型:">
            <el-input v-model="dialogForm.carModel" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="trailerCarNumber" label="挂车车牌号:">
            <el-input v-model="dialogForm.trailerCarNumber" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="carOwnersAddress" label="车主地址:">
            <el-input v-model="dialogForm.carOwnersAddress" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="surchargeNumber" label="附加费证号:">
            <el-input v-model="dialogForm.surchargeNumber" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="operatingNumber" label="运营证号:">
            <el-input v-model="dialogForm.operatingNumber" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="policyNumber	" label="保险单号:">
            <el-input v-model="dialogForm.policyNumber" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="peerDriver	" label="同行驾驶员:">
            <el-input v-model="dialogForm.peerDriver" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="peerDriverLicenseNumber" label="同行驾驶证号:">
            <el-input v-model="dialogForm.peerDriverLicenseNumber" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="tollNumber" label="养路费号:">
            <el-input v-model="dialogForm.tollNumber" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="companyAddress" label="单位地址:">
            <el-input v-model="dialogForm.companyAddress" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="vehicleCompany" label="车属单位:">
            <el-input v-model="dialogForm.vehicleCompany" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <!-- 
          <el-form-item class="dialogFormItems" prop="a6" label="adas:">
            <el-select v-model="dialogForm.a6" placeholder="请选择活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>-->

          <el-form-item class="dialogFormItemsTime" prop="expectedArrivalTime" label="预计到达时间:">
            <el-date-picker v-model="dialogForm.expectedArrivalTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" default-time="12:00:00" placeholder="选择日期时间"></el-date-picker>
          </el-form-item>
          <el-form-item class="dialogFormItemsTime" prop="requestArrivalTime" label="要求到达时间:">
            <el-date-picker v-model="dialogForm.requestArrivalTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" default-time="12:00:00" placeholder="选择日期时间"></el-date-picker>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks	" label="备注:">
            <el-input type="textarea" rows="2" v-model="dialogForm.remarks"></el-input>
          </el-form-item>
          <!-- <el-form-item label="图片:">
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="6"
            ></uploadimgs>
          </el-form-item>-->
        </el-form>
      </div>
    </myDialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    ></exportCompoent>
  </div>
</template>
<script>
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import addCustomerTarck from "@/components/CustomerServiceTrackingNew.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    multitime,
    addCustomerTarck,
    myDialog,
    uploadimgs,
    queryBtns,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "发车合同管理列表",
        apiName: "/admin/v3/tms/dispatch/contract/getDispatchContractList", //导出的数据列表接口名
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        pageType: "DepartureContractManagement", //页面类型(主要用来区分查询参参数的时间)
      },
      //=======================导出相关 结束 =======================
      //  -----  查询  ------
      queryData: {
        name: "",
        region: "",
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "创建日期",
        },
        {
          value: "1",
          label: "业务日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",

      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据

      show_sortTableHeard: false, //显示表格设置弹窗
      // 默认表头
      tabelHeadeTitle: [
        {
          name: "发车合同编号",
          field: "number",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "托运单位",
          field: "shippingCompany",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "托运电话",
          field: "shippingTel",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货单位",
          field: "receiptCompany",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货电话",
          field: "receiptPhone",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "始发城市",
          field: "startCity",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "目的城市",
          field: "endCity",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物名称",
          field: "goodsName	",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "总件数",
          field: "totalCount",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "总体积(m³)",
          field: "totalVolume",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "总重量(kg)",
          field: "totalWeight",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "承运单位",
          field: "carrierCompany",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机姓名",
          field: "driverName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机身份证号",
          field: "driverIdcard",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机电话",
          field: "driverPhone",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "驾驶证号",
          field: "driverLicenseNumber",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "备注",
          field: "remarks",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "新建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "新建人",
          field: "createUserName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "修改时间",
          field: "aaaaaa",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "修改人",
          field: "aaaaaa",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      myTableHeard: [], //  我的表头
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      tableData: [], //  表格数据

      allCheck: false, //  全选
      sortName: "发车合同模板", //  排序名
      selectLength: 0, //  显示的长度

      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "DepartureContractManagement", //  页面标识

      // 新建客服跟踪
      showDia1: false,
      documentNumbers: "",
      documentStatus: "", //包裹单据

      fileNameLists: [], //上传组件的
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "60%",
      dialogForm: {
        // 弹窗表单数据
        number: "",
        carFrameNumber: "",
        carModel: "",
        carOwners: "",
        carOwnersAddress: "",
        carrierCompany: "",
        companyAddress: "",
        driverAddress: "",
        driverIdcard: "",
        driverLicenseNumber: "",
        driverName: "",
        driverPhone: "",
        driverTel: "",
        drivingLicenseNumber: "",
        endCity: "",
        engineNumber: "",
        expectedArrivalTime: "",
        goodsName: "",
        operatingNumber: "",
        peerDriver: "",
        peerDriverLicenseNumber: "",
        policyNumber: "",
        receiptCompany: "",
        receiptPhone: "",
        remarks: "",
        requestArrivalTime: "",
        shippingCompany: "",
        shippingTel: "",
        startCity: "",
        surchargeNumber: "",
        tollNumber: "",
        totalCount: "1",
        totalVolume: "",
        totalWeight: "",
        trailerCarNumber: "",
        vehicleCompany: "",
      },
      rulesForm: {
        number: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====

      diaType: "",
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;;

    //获取默认表头
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
  },
  activated() {
    // 每次进页面都会触发的写这里
    //计算获取表格高度
    this.fetTableHeight();
    this.getData();
  },
  mounted() {
    //计算获取表格高度
    // this.fetTableHeight();
  },
  watch: {},
  methods: {
    setMyModel() {
      this.$TOOLS.myModel(this);
    },
    // 新建合同
    transportPlan() {
      this.isShowDialog = true;
      this.dialogTitle = "新建发车合同";
      this.diaType = "add";
    },
    // 修改合同
    WaybillEdit(row) {
      this.$API
        .wtl_getDispatchContractDetail({ contractId: row.contractId })
        .then((res) => {
          this.dialogForm = res.data.result;
          this.isShowDialog = true;
          this.dialogTitle = "修改发车合同";
          this.diaType = "edit";
        });
    },
    // 删除
    delBtns(val) {
      let ids = [];
      // 右边单选
      if (val) {
        ids.push(val.contractId);
      } else {
        // 上面多选
        if (this.selectTableData.length < 1) {
          this.$message.error("请至少选择一条数据进行操作");
          return false;
        }
        ids = this.selectTableData.map((item) => {
          return item.contractId;
        });
      }

      this.$confirm("确定要删除所选合同单吗吗? 请谨慎操作", "提示:")
        .then(() => {
          this.$API
            .wtl_delDispatchContract({ contractIds: ids })
            .then((res) => {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
            });
        })
        .catch((err) => {});
    },

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = JSON.parse(JSON.stringify(this.dialogForm));
          param.totalCount = param.totalCount || 0;
          param.totalVolume = param.totalVolume || 0;
          param.totalWeight = param.totalWeight || 0;
          if (this.diaType == "add") {
            this.$API.wtl_addDispatchContract(param).then((res) => {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
              this.isShowDialog = false;
            });
          } else {
            this.$API.wtl_updateDispatchContract(param).then((res) => {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
              this.isShowDialog = false;
            });
          }
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 跳转运单详情
    goYdDetails(a) {
      // this.$router.push({
      //   path: "/WaybillManage/WaybillDetails",
      //   query: {
      //     yd: "123",
      //   },
      // });
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || "0";
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },

    // 提交新建客服跟踪
    confirmAdd(formName) {
      this.showDia1 = false;
      this.getData();
    },
    // 关闭客户跟踪弹窗,重置弹窗数据
    closeDia1(e) {
      this.showDia1 = e || false;
      this.documentNumbers = ""; //如果不重置这个,第二次点开同样的数据组件不会监听到变化默认是空的
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    rowclick2(row, event, column) {
      this.$refs.memberTable.toggleRowSelection(row);
    },

    getData() {
      let param = {
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
      };

      this.$API.wtl_getDispatchContractList(param).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {};
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val;
      this.getData();
    },

    AddPackage() {
      //  添加包裹
      this.$router.push({
        path: "/BusinessManagement/addPacks",
      });
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    ModifyPackage() {
      //  修改包裹
      if (this.selectTableData.length === 1) {
        this.$router.push({
          path: "/BusinessManagement/addPacks",
          query: {
            packageId: this.selectTableData[0].packageId,
          },
        });
      } else {
        this.$message.error("请选一个需要修改的包裹");
      }
    },

    PackageDetails() {
      //  包裹详情
      if (this.selectTableData.length > 0) {
        this.$router.push({
          path: "/BusinessManagement/packsDetails",
          query: {
            packageId: this.selectTableData[0].packageId,
            courierNumber: this.selectTableData[0].courierNumber,
          },
        });
      } else {
        this.$router.push({
          path: "/BusinessManagement/packsDetails",
        });
      }
    },
    dabaoDetails() {
      //  包裹详情
      if (this.selectTableData.length === 1) {
        if (
          this.selectTableData[0].packageStatus ==
            "chu_ku_zai_tu:package_status" ||
          this.selectTableData[0].packageStatus ==
            "ke_hu_qian_shou:package_status" ||
          this.selectTableData[0].packageStatus ==
            "chu_ku_zhong:package_status" ||
          this.selectTableData[0].packageStatus ==
            "da_bao_wan_cheng:package_status"
        ) {
          this.$router.push({
            path: "/BusinessManagement/dabaoDetails",
            query: {
              packageId: this.selectTableData[0].packageId,
            },
          });
        } else {
          this.$message.error("包裹未打包完成");
        }
      } else {
        this.$message.error("请选择一个包裹");
      }
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }

      // if (a === "dc") {
      //   // 导出
      //   this.exportBtn();
      // }

      if (a === "jtdc") {
        // 新版导出
        this.isShowDialog_dc = true;
      }
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },
    //点击更多操作下的按钮
    handleCommandBtns(type, val) {
      console.log(type);
      console.log(val);
      // a==详情
      if (type === "a") {
        this.$router.push("/WaybillManage/WaybillDetails");
      }
      // d==删除
      if (type === "d") {
        this.delBtns(val);
      }
    },

    //    -------------  设置列表表头方法  ------------

    getGroupFindFieldSort() {
      //  获取自定义的排序,没有就用默认的
      this.$API
        .getGroupFindFieldSort({
          groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || [];
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              this.myTableHeard = JSON.parse(arr[0].sortObject);
              this.sortName = arr[0].sortName;
            }
          } else {
            this.myTableHeard = this.tabelHeadeTitle;
          }
          let totalArr = [];
          //提取需要合计的字段
          for (var i = 0; i < this.myTableHeard.length; i++) {
            if (this.myTableHeard[i].isTotal) {
              totalArr.push(this.myTableHeard[i].field);
            }
          }
          this.totalArr = totalArr;
        });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },

    // ==========排序表头的组件方法==========
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    /****
     *  ===================上面页面公共方法 end ===================
     *
     */
  },
};
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}

.diaForm {
  .itemsRows {
    width: 100%;
  }

  .itemTydw {
    width: 100%;
    display: flex;
    .tydw {
      flex: 2;
    }

    .tydh {
      flex: 1;
    }
  }
}
</style>
